<template>
  <v-dialog v-model="dialog">
    <v-layout class="dialog-container" row justify-center>
      <v-card>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0 primary--text">
              <Countdown
                :showLabel="false"
                :color="expiration ? '#0067af' : '#ff5722'"
                :date="expiration"
              />
            </h3>
            <h3 class="headline mb-0" v-if="expiration">Sua sessão expirou.</h3>
          </div>
        </v-card-title>

        <v-card-text>
          <span
            class="grey--text"
            v-if="expiration"
          >Por favor, reinicie sua compra e garanta seus ingressos!</span>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" class="normal-text" flat outline round @click="exitAction">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Countdown from './Countdown';

export default {
  props: {
    expiration: {
      type: Number,
      default: 0,
    },
    continue: {
      type: Function,
      default: () => {},
    },
    exit: {
      type: Function,
      default: () => {},
    },
  },
  components: { Countdown },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapGetters({
      expirationDialog: 'expirationDialog',
    }),
  },
  methods: {
    ...mapActions({
      refreshExpirationTime: 'refreshExpirationTime',
    }),
    successAction() {
      this.dialog = false;
      this.refreshExpirationTime(this.$store.getters.eventID);
      this.$store.dispatch('setExpirationDialog', false);
    },
    exitAction() {
      this.$store.dispatch('setCurrentStep', 1);
      const evento = this.$store.getters.eventID;
      this.$store.dispatch('deleteCheckoutState', evento);
      this.$store.dispatch('loadCheckoutState', evento);

      this.dialog = false;
      this.$store.dispatch('sendPostMessage', {
        open: true,
        logged: false,
        userToken: null,
      });
    },
  },
  watch: {
    expirationDialog(val) {
      this.dialog = val;
    },
  },
};
</script>

<style scoped>
.dialog-container {
  max-width: 320px;
  margin: auto;
}
.v-card__actions {
  padding: 16px;
}
</style>
